module.exports = __webpack_public_path__ + "media/assets/images/flags/kp-aeb71452d03cb19d5df9a95a2ba9e917.svg";